/** @format */
import { useEffect, useLayoutEffect } from 'react';

/**
 * Stops SSR warnings when using useLayoutEffect
 *
 * @see https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
 */
export const useIsomorphicLayoutEffect =
    typeof window !== 'undefined' ? useLayoutEffect : useEffect;
